[
  {
    "id": "member-1",
    "organizationId": "org-123",
    "iamId": "mock-user-id",
    "firstName": "John",
    "lastName": "Smith",
    "position": "Senior Developer",
    "roles": ["organization_user"],
    "activityState": "ACTIVE"
  },
  {
    "id": "member-2",
    "organizationId": "org-123",
    "firstName": "Sarah",
    "lastName": "Johnson",
    "position": "Project Manager",
    "roles": ["organization_user"],
    "activityState": "INACTIVE"
  },
  {
    "id": "member-3",
    "organizationId": "org-123",
    "firstName": "Alice",
    "lastName": "Johnson",
    "position": "CEO",
    "roles": ["organization_admin", "organization_representative", "organization_user"],
    "activityState": "ACTIVE"
  },
  {
    "id": "member-4",
    "organizationId": "org-456",
    "firstName": "Emma",
    "lastName": "Davis",
    "position": "Technical Lead",
    "roles": ["organization_user"],
    "activityState": "ACTIVE"
  },
  {
    "id": "member-5",
    "organizationId": "org-456",
    "firstName": "Robert",
    "lastName": "Wilson",
    "position": "Project Coordinator",
    "roles": ["organization_user"],
    "activityState": "INACTIVE"
  },
  {
    "id": "member-6",
    "organizationId": "org-456",
    "firstName": "Bob",
    "lastName": "Smith",
    "position": "Managing Director",
    "roles": ["organization_admin", "organization_representative", "organization_user"],
    "activityState": "ACTIVE"
  },
  {
    "id": "member-7",
    "organizationId": "org-789",
    "firstName": "Lisa",
    "lastName": "Anderson",
    "position": "Operations Manager",
    "roles": ["organization_user"],
    "activityState": "ACTIVE"
  },
  {
    "id": "member-8",
    "organizationId": "org-789",
    "firstName": "James",
    "lastName": "Taylor",
    "position": "Engineer",
    "roles": ["organization_user"],
    "activityState": "INACTIVE"
  },
  {
    "id": "member-9",
    "organizationId": "org-789",
    "firstName": "Maria",
    "lastName": "Schmidt",
    "position": "Founder & CEO",
    "roles": ["organization_admin", "organization_representative", "organization_user"],
    "activityState": "ACTIVE"
  },
  {
    "id": "member-10",
    "organizationId": "org-234",
    "firstName": "Patricia",
    "lastName": "Martinez",
    "position": "Business Analyst",
    "roles": ["organization_user"],
    "activityState": "ACTIVE"
  },
  {
    "id": "member-11",
    "organizationId": "org-234",
    "firstName": "David",
    "lastName": "Garcia",
    "position": "Development Lead",
    "roles": ["organization_user"],
    "activityState": "INACTIVE"
  },
  {
    "id": "member-12",
    "organizationId": "org-234",
    "firstName": "Thomas",
    "lastName": "Müller",
    "position": "CTO",
    "roles": ["organization_admin", "organization_representative", "organization_user"],
    "activityState": "ACTIVE"
  },
  {
    "id": "member-13",
    "organizationId": "org-567",
    "firstName": "Christopher",
    "lastName": "Lee",
    "position": "Research Coordinator",
    "roles": ["organization_user", "organization_admin"],
    "activityState": "ACTIVE"
  },
  {
    "id": "member-14",
    "organizationId": "org-567",
    "firstName": "Mary",
    "lastName": "Harris",
    "position": "Lab Manager",
    "roles": ["organization_user"],
    "activityState": "INACTIVE"
  },
  {
    "id": "member-15",
    "organizationId": "org-567",
    "firstName": "Sarah",
    "lastName": "Weber",
    "position": "Chief Scientific Officer",
    "roles": ["organization_admin", "organization_user", "organization_representative"],
    "activityState": "ACTIVE"
  }
]
